export { SlotItem as default };

/**
 * This class is a model that represents an ad slot item, it stores all the information about the ad slot,
 * such as its id, size, visibility, etc. It also has a method to clear the slot information when the slot is destroyed
 *
 * @author      William Lopes <william.c.lopes@meo.pt>
 * @copyright   Copyright (C) SAPO. All rights reserved.
 * @license     Private
 */
class SlotItem
{
    id = null;
    
    slot = null;

    size_key = null;

    refresh_interval = null;
    
    sizes = null;
    
    element = null;
    
    is_rendered = false;
    
    fallback_image = null;
    
    is_fallback_visible = false;
    
    is_creative_empty = false;

    observer = null;

    render_check = null;
    
    setId(value) {
        this.id = value;
    }
    
    setSlot(value) {
        this.slot = value;
    }
    
    setSizeKey(value) {
        this.size_key = value;
    }
    
    setRefreshInterval(value) {
        this.refresh_interval = value;
    }
    
    setSizes(value) {
        this.sizes = value;
    }
    
    setElement(value) {
        this.element = value;
    }
    
    setIsRendered(value) {
        this.is_rendered = value;
    }
    
    setFallbackImage(value) {
        this.fallback_image = value;
    }
    
    setFallbackVisibility(value) {
        this.is_fallback_visible = value;
    }
    
    setIsCreativeEmpty(value) {
        this.is_creative_empty = value;
    }
    
    setObserver(value) {
        this.observer = value;
    }

    setRenderCheck(value) {
        this.render_check = value;
    }
    
    getId() {
        return this.id;
    }
    
    getSlot() {
        return this.slot;
    }

    getSizeKey() {
        return this.size_key;
    }
    
    getRefreshInterval() {
        return this.refresh_interval;
    }
    
    getSizes() {
        return this.sizes;
    }
    
    getElement() {
        return this.element;
    }
    
    getIsRendered() {
        return this.is_rendered;
    }
    
    getFallbackSrc() {
        return this.fallback_image;
    }
    
    getFallbackVisibility() {
        return this.is_fallback_visible;
    }
    
    getIsCreativeEmpty() {
        return this.is_creative_empty;
    }
    
    getObserver() {
        return this.observer;
    }

    getRenderCheck() {
        return this.render_check;
    }

    // repoe o estado ligado ao slot GPT, depois de este ser destruido.
    reset() {
        this.slot              = null;
        this.sizes             = null;
        this.size_key          = null;
        this.is_rendered       = false;
        this.is_creative_empty = false;
    }
}
